<template>
   <Breadcrumb
      :home="breadcrumb.home"
      :model="breadcrumb.items"
      :pt="{
         root: {
            style: {
               width: '100%',
               border: 'none',
               margin: '0',
               marginBottom: '0.5rem',
               padding: '0',
               background: 'transparent',
               boxShadow: 'none',
               overflow: 'visible',
               maxHeight: 'none',
               height: 'auto',
               textAlign: 'left',
            },
         },
         list: {
            style: {
               margin: '0',
               padding: '0',
               border: 'none',
               overflow: 'visible',
               maxHeight: 'none',
               height: 'auto',
            },
         },
         item: {
            style: {
               margin: '0',
               padding: '0',
               fontSize: '0.7rem',
               lineHeight: '1.2',
               border: 'none',
               color: '#334155',
            },
         },
         chevron: {
            style: {
               margin: '0 0.2rem',
               padding: '0',
               fontSize: '0.7rem',
               lineHeight: '1.2',
               border: 'none',
               color: '#334155',
            },
         },
         home: {
            style: {
               padding: '0',
               margin: '0',
               marginRight: '0.2rem',
               border: 'none',
               fontSize: '0.7rem',
               lineHeight: '1.2',
               color: '#334155',
            },
         },
         homeIcon: {
            style: {
               fontSize: '0.7rem',
               lineHeight: '1.2',
               color: '#334155',
            },
         },
      }"
   >
      <template #item="{ item, props }">
         <router-link
            v-if="item.route"
            v-slot="{ href, navigate }"
            :to="item.route"
            custom
         >
            <a :href="href" v-bind="props.action" class="breadcrumb-link-fixed" @click="navigate">
               <i v-if="item.icon" :class="item.icon"></i>
               <span v-if="item.label">{{ item.label }}</span>
            </a>
         </router-link>
         <span v-else class="breadcrumb-current">
            <i v-if="item.icon" :class="item.icon"></i>
            <span v-if="item.label">{{ item.label }}</span>
         </span>
      </template>
   </Breadcrumb>
</template>

<script setup>
import { useBreadcrumb } from '@/composables/useBreadcrumb';
import Breadcrumb from 'primevue/breadcrumb';

const { breadcrumb } = useBreadcrumb();
</script>

<style scoped>
:deep(.breadcrumb-link-fixed),
:deep(.breadcrumb-link-fixed:link),
:deep(.breadcrumb-link-fixed:visited),
:deep(.breadcrumb-link-fixed:hover),
:deep(.breadcrumb-link-fixed:active),
:deep(.breadcrumb-link-fixed:focus) {
   color: #334155 !important;
   text-decoration: none;
}

:deep(.breadcrumb-current) {
   color: #334155;
   font-weight: bold;
}
</style>

